module.exports = __webpack_public_path__ + "img/novel_illu.3e521973.png";